<template>
  <tooltip :screen-padding="0" class="tooltip-wrapper right-zero">
    <template #toggle>
      <icon icon="info" class="toggle-icon" />
    </template>
    <div class="repayment-type-tooltip-text">
      <p>
        {{ repayment.repaymentTypeDetails?.name || repayment?.repaymentTypeName }}
      </p>
      <p>
        {{ repayment.repaymentTypeTooltipText }}
      </p>
    </div>
  </tooltip>
</template>
<script setup lang="ts">
import { defineProps } from "vue";
import Tooltip from "@/components/pel-loan-configuration/Tooltip.vue";
import Icon from "@/components/shared/Icon.vue";

const props = defineProps({
  repayment: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped>
.tooltip-wrapper .repayment-type-tooltip-text p {
  color: #000;
  font-family: var(--header-font);
  font-size: 0.75rem;
  font-style: normal;
  font-weight: var(--font-weight-normal);
  line-height: 15px; /* 125% */
  margin-bottom: 0;
}

.tooltip-wrapper .repayment-type-tooltip-text :first-child {
  font-weight: var(--font-weight-bold);
  margin-bottom: 0px;
  line-height: 21px; /* 175% */
}

.repayment-option-tooltip .icon {
  height: 16px;
  width: 16px;
  color: #000;
  flex-shrink: 0;
}
.toggle-icon {
  fill: #000;
  height: 12px;
  width: 12px;
  color: #000;
}
</style>
